
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.111 0H.89C.4 0 0 .4 0 .889v5.333c0 .49.4.89.889.89H15.11c.489 0 .889-.4.889-.89V.89a.89.89 0 00-.888-.89zM1.778 5.333h12.444V1.778H1.778v3.555zM.888 8.89h14.223c.489 0 .889.4.889.889v5.333c0 .489-.4.889-.889.889H.89a.891.891 0 01-.89-.89V9.778c0-.49.4-.89.889-.89zm13.334 1.778H1.778v3.555h12.444v-3.555zm-10.666 3.11a1.337 1.337 0 01-1.334-1.333c0-.737.605-1.333 1.334-1.333.728 0 1.333.596 1.333 1.333 0 .738-.596 1.334-1.333 1.334zM2.222 3.557c0 .737.605 1.333 1.334 1.333.737 0 1.333-.605 1.333-1.333 0-.73-.605-1.334-1.333-1.334-.73 0-1.334.596-1.334 1.334z","fill":"#FCB269"}})])
          )
        }
      }
    